<template>
  <div class="raw-material-approval-report-view pa-4">
    <!-- 1. Encabezado de Título Neutro -->
    <v-card class="mb-4 rounded-xl border-light" outlined elevation="0">
      <v-card-title class="d-flex align-center py-4 px-5 flex-wrap">
        <v-avatar color="grey lighten-4" size="48" class="mr-4">
          <v-icon color="primary" large>mdi-shield-check-outline</v-icon>
        </v-avatar>
        <div>
          <h2 class="text-h6 font-weight-black grey--text text--darken-4 mb-0">
            Reporte de Aprobación de Materia Prima por Lote
          </h2>
          <span class="text-caption grey--text text--darken-2">
            Consolidado de certificaciones, vigencias, dictámenes de pesticidas y metales pesados, mercados aptos y observaciones.
          </span>
        </div>
      </v-card-title>
    </v-card>

    <!-- 2. Leyenda de Estados de Aprobación (Cuadro pequeño alineado a la derecha - Ocupa 1/3) -->
    <div class="mb-4 d-flex justify-end">
      <v-card class="rounded-xl border-light bg-white overflow-hidden elevation-0" outlined style="max-width: 390px; width: 100%;">
        <div
          class="py-1 px-3 d-flex align-center"
          style="background-color: #f8fafc; border-bottom: 1px solid #e2e8f0;"
        >
          <v-icon color="grey darken-3" small class="mr-2">mdi-bookmark-outline</v-icon>
          <span class="text-caption font-weight-black grey--text text--darken-4 text-uppercase" style="letter-spacing: 0.5px; font-size: 11px !important;">
            Leyenda
          </span>
        </div>

        <div class="pa-2">
          <div class="d-flex flex-column" style="gap: 4px;">
            <!-- APROBADO -->
            <div class="d-flex align-center px-2 py-1 rounded" style="background-color: #f8fafc; border: 1px solid #e2e8f0;">
              <v-chip
                x-small
                class="font-weight-bold text-uppercase mr-2 flex-shrink-0"
                color="green lighten-5"
                text-color="green darken-3"
                style="min-width: 105px; justify-content: center;"
              >
                <v-icon left x-small color="green darken-3">mdi-check-circle</v-icon>
                APROBADO
              </v-chip>
              <span class="text-caption grey--text text--darken-4 font-weight-medium" style="font-size: 11px !important; line-height: 1.2;">
                Liberado para todo destino.
              </span>
            </div>

            <!-- RESTRINGIDO -->
            <div class="d-flex align-center px-2 py-1 rounded" style="background-color: #f8fafc; border: 1px solid #e2e8f0;">
              <v-chip
                x-small
                class="font-weight-bold text-uppercase mr-2 flex-shrink-0"
                color="orange lighten-5"
                text-color="orange darken-4"
                style="min-width: 105px; justify-content: center;"
              >
                <v-icon left x-small color="orange darken-4">mdi-shield-alert-outline</v-icon>
                RESTRINGIDO
              </v-chip>
              <span class="text-caption grey--text text--darken-4 font-weight-medium" style="font-size: 11px !important; line-height: 1.2;">
                Con restricción por Análisis para algunos países de Exportación.
              </span>
            </div>

            <!-- OBSERVADO -->
            <div class="d-flex align-center px-2 py-1 rounded" style="background-color: #f8fafc; border: 1px solid #e2e8f0;">
              <v-chip
                x-small
                class="font-weight-bold text-uppercase mr-2 flex-shrink-0"
                color="purple lighten-5"
                text-color="purple darken-3"
                style="min-width: 105px; justify-content: center;"
              >
                <v-icon left x-small color="purple darken-3">mdi-clock-alert-outline</v-icon>
                OBSERVADO
              </v-chip>
              <span class="text-caption grey--text text--darken-4 font-weight-medium" style="font-size: 11px !important; line-height: 1.2;">
                Pendiente de documentación.
              </span>
            </div>

            <!-- NO CONFORME -->
            <div class="d-flex align-center px-2 py-1 rounded" style="background-color: #f8fafc; border: 1px solid #e2e8f0;">
              <v-chip
                x-small
                class="font-weight-bold text-uppercase mr-2 flex-shrink-0"
                color="red lighten-5"
                text-color="red darken-3"
                style="min-width: 105px; justify-content: center;"
              >
                <v-icon left x-small color="red darken-3">mdi-close-circle</v-icon>
                NO CONFORME
              </v-chip>
              <span class="text-caption grey--text text--darken-4 font-weight-medium" style="font-size: 11px !important; line-height: 1.2;">
                No apta para Exportación.
              </span>
            </div>
          </div>
        </div>
      </v-card>
    </div>

    <!-- 3. Panel de Filtros -->
    <v-card class="mb-4 rounded-xl border-light" outlined elevation="0">
      <v-card-title class="py-3 px-5 d-flex align-center flex-wrap">
        <v-icon color="grey darken-3" small class="mr-2">mdi-filter-variant</v-icon>
        <span class="text-subtitle-2 font-weight-bold grey--text text--darken-4 text-uppercase">
          Filtros de Búsqueda
        </span>
      </v-card-title>
      <v-divider></v-divider>

      <v-card-text class="py-4 px-5">
        <v-row dense align="center">

          <!-- <v-col cols="12" sm="6" md="4" lg="2">
            <s-date
              label="Fecha Desde"
              v-model="filters.BeginDate"
              clearable
            />
          </v-col>

          <v-col cols="12" sm="6" md="4" lg="2">
            <s-date
              label="Fecha Hasta"
              v-model="filters.EndDate"
              clearable
            />
          </v-col> -->

          <v-col cols="12" sm="6" md="4" lg="3">
            <s-select-campaign-area
              label="Campaña"
              v-model="filters.CmaID"
              typeArea="1"
              clearable
              noDefault
            />
          </v-col>

          <v-col cols="12" sm="6" md="4" lg="3">
            <s-select-lot
              label="ID"
              v-model="filters.FltID"
              clearable
              full
              noDefault
            />
          </v-col>

          <v-col cols="12" sm="6" md="4" lg="2">
            <s-select-definition
              label="Cultivo"
              :def="1173"
              v-model="filters.TypeCultive"
              clearable
            />
          </v-col>

          <v-col cols="12" sm="6" md="4" lg="2">
            <s-select-definition
              label="Tipo de Proveedor"
              :def="1160"
              v-model="filters.TypeSupplier"
              clearable
            />
          </v-col>

          <v-col cols="12" sm="6" md="4" lg="2">
            <s-select-definition
              label="Planta de Proceso"
              :def="1750"
              v-model="filters.TypeProcessingPlant"
              clearable
            />
          </v-col>
        </v-row>

        <v-row dense class="mt-2">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="mr-2 px-4 rounded-lg font-weight-bold white--text text-none"
            elevation="0"
            height="40"
            :loading="loading"
            @click="loadApprovalReport"
          >
            <v-icon left small>mdi-magnify</v-icon>
            Consultar
          </v-btn>

          <v-btn
            color="success"
            class="px-4 rounded-lg font-weight-bold white--text text-none"
            elevation="0"
            height="40"
            :disabled="approvalList.length === 0"
            @click="exportToExcel"
          >
            <v-icon left small>mdi-file-excel</v-icon>
            Exportar Excel
          </v-btn>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- 4. Grilla Principal -->
    <v-card class="rounded-xl border-light bg-white" outlined elevation="0">
      <div class="pa-4 d-flex align-center justify-space-between flex-wrap">
        <div style="max-width: 380px; width: 100%;">
          <v-text-field
            v-model="searchText"
            dense
            outlined
            hide-details
            placeholder="Buscar por lote, productor, certificación, zona..."
            prepend-inner-icon="mdi-magnify"
            clearable
            class="rounded-lg"
          />
        </div>
        <div class="text-caption grey--text text--darken-2 font-weight-bold mt-2 mt-sm-0">
          Mostrando {{ filteredList.length }} de {{ approvalList.length }} lotes
        </div>
      </div>

      <v-data-table
        :headers="headers"
        :items="filteredList"
        :loading="loading"
        dense
        class="elevation-0 approval-table"
        :items-per-page="15"
        :footer-props="{
          'items-per-page-options': [10, 15, 25, 50, 100],
          'show-current-page': true,
        }"
      >
        <!-- Lote -->
        <template v-slot:[`item.FltID`]="{ item }">
          <span class="font-weight-black grey--text text--darken-4">
            {{ item.FltID || '-' }}
          </span>
        </template>

        <!-- Productor -->
        <template v-slot:[`item.PrdCardName`]="{ item }">
          <span class="font-weight-bold grey--text text--darken-4">
            {{ item.PrdCardName || '-' }}
          </span>
        </template>

        <!-- Certificaciones -->
        <template v-slot:[`item.Certification`]="{ item }">
          <div v-if="item.Certification" style="min-width: 180px;">
            <v-chip
              v-for="(cert, idx) in parseCertifications(item.Certification)"
              :key="idx"
              x-small
              class="font-weight-bold mr-1 mb-1"
              color="teal lighten-5"
              text-color="teal darken-3"
            >
              {{ cert }}
            </v-chip>
          </div>
          <span v-else class="grey--text text--lighten-1">-</span>
        </template>

        <!-- Requiere Análisis -->
        <template v-slot:[`item.RequiresAnalysis`]="{ item }">
          <v-chip
            v-if="item.RequiresAnalysis === 1 || item.RequiresAnalysis === '1' || item.RequiresAnalysis === true"
            x-small
            class="font-weight-bold"
            color="blue lighten-5"
            text-color="blue darken-3"
          >
            <v-icon left x-small>mdi-flask-outline</v-icon>
            SÍ
          </v-chip>
          <v-chip
            v-else
            x-small
            class="font-weight-bold"
            color="grey lighten-4"
            text-color="grey darken-2"
          >
            <v-icon left x-small>mdi-flask-off-outline</v-icon>
            NO
          </v-chip>
        </template>

        <!-- Fechas y Vigencia Metal -->
        <template v-slot:[`item.MetalAnalysisDate`]="{ item }">
          {{ formatDate(item.MetalAnalysisDate) }}
        </template>
        <template v-slot:[`item.MetalAnalysisExpirationDate`]="{ item }">
          {{ formatDate(item.MetalAnalysisExpirationDate) }}
        </template>
        <template v-slot:[`item.MetalAnalysisValidity`]="{ item }">
          <v-chip
            v-if="item.MetalAnalysisValidity"
            x-small
            class="font-weight-bold text-uppercase"
            :color="getValidityColor(item.MetalAnalysisValidity).bg"
            :text-color="getValidityColor(item.MetalAnalysisValidity).text"
          >
            {{ item.MetalAnalysisValidity }}
          </v-chip>
          <span v-else class="grey--text text--lighten-1">-</span>
        </template>

        <!-- Plomo -->
        <template v-slot:[`item.PLOMO`]="{ item }">
          <span :class="item.PLOMO ? 'font-weight-bold font-mono red--text text--darken-2' : 'grey--text text--lighten-1'">
            {{ formatDecimal(item.PLOMO) }}
          </span>
        </template>

        <!-- Cadmio -->
        <template v-slot:[`item.CADMIO`]="{ item }">
          <span :class="item.CADMIO ? 'font-weight-bold font-mono red--text text--darken-2' : 'grey--text text--lighten-1'">
            {{ formatDecimal(item.CADMIO) }}
          </span>
        </template>

        <!-- Níquel -->
        <template v-slot:[`item.NIQUEL`]="{ item }">
          <span :class="item.NIQUEL ? 'font-weight-bold font-mono red--text text--darken-2' : 'grey--text text--lighten-1'">
            {{ formatDecimal(item.NIQUEL) }}
          </span>
        </template>

        <!-- Fechas y Vigencia Pesticida -->
        <template v-slot:[`item.PesticideAnalysisDate`]="{ item }">
          {{ formatDate(item.PesticideAnalysisDate) }}
        </template>
        <template v-slot:[`item.PesticideAnalysisExpirationDate`]="{ item }">
          {{ formatDate(item.PesticideAnalysisExpirationDate) }}
        </template>
        <template v-slot:[`item.PesticideAnalysisValidity`]="{ item }">
          <v-chip
            v-if="item.PesticideAnalysisValidity"
            x-small
            class="font-weight-bold text-uppercase"
            :color="getValidityColor(item.PesticideAnalysisValidity).bg"
            :text-color="getValidityColor(item.PesticideAnalysisValidity).text"
          >
            {{ item.PesticideAnalysisValidity }}
          </v-chip>
          <span v-else class="grey--text text--lighten-1">-</span>
        </template>

        <!-- Residuos / Trazas -->
        <template v-slot:[`item.ResiduosTrazas`]="{ item }">
          <div v-if="item.ResiduosTrazas" class="purple--text text--darken-3 font-weight-medium text-wrap" style="min-width: 180px; font-size: 0.8rem; line-height: 1.35;">
            {{ item.ResiduosTrazas }}
          </div>
          <span v-else class="grey--text text--lighten-1">-</span>
        </template>

        <!-- Positivos -->
        <template v-slot:[`item.Positivos`]="{ item }">
          <div v-if="item.Positivos" class="blue--text text--darken-3 font-weight-medium text-wrap" style="min-width: 180px; font-size: 0.8rem; line-height: 1.35;">
            {{ item.Positivos }}
          </div>
          <span v-else class="grey--text text--lighten-1">-</span>
        </template>

        <!-- Dictamen Final -->
        <template v-slot:[`item.ConsolidatedStatus`]="{ item }">
          <div style="min-width: 170px;">
            <!-- La decisión principal la da Aprobación de Proveedores (SupplierApprovalStatus) -->
            <v-chip
              small
              class="font-weight-bold text-uppercase mb-1"
              :color="getStatusColor(item.SupplierApprovalStatus || item.ConsolidatedStatus).bg"
              :text-color="getStatusColor(item.SupplierApprovalStatus || item.ConsolidatedStatus).text"
            >
              <v-icon left x-small>{{ getStatusColor(item.SupplierApprovalStatus || item.ConsolidatedStatus).icon }}</v-icon>
              {{ formatStatusText(item.SupplierApprovalStatus || item.ConsolidatedStatus) }}
            </v-chip>

            <!-- Si Requiere Análisis (RequiresAnalysis == 1), mostramos los sub-estados de Pesticida y Metal -->
            <div
              v-if="item.RequiresAnalysis === 1 || item.RequiresAnalysis === '1' || item.RequiresAnalysis === true"
              class="d-flex flex-column mt-1"
              style="font-size: 0.72rem; line-height: 1.35;"
            >
              <div class="d-flex align-center mb-1">
                <span class="font-weight-bold grey--text text--darken-3 mr-1" style="min-width: 58px;">Pesticida:</span>
                <v-chip
                  x-small
                  class="font-weight-bold text-uppercase"
                  :color="getStatusColor(item.PesticideStatus).bg"
                  :text-color="getStatusColor(item.PesticideStatus).text"
                  style="height: 19px; font-size: 0.68rem;"
                >
                  <v-icon left style="font-size: 11px; margin-right: 2px;">{{ getStatusColor(item.PesticideStatus).icon }}</v-icon>
                  {{ formatStatusText(item.PesticideStatus) }}
                </v-chip>
              </div>
              <div class="d-flex align-center">
                <span class="font-weight-bold grey--text text--darken-3 mr-1" style="min-width: 58px;">Metal:</span>
                <v-chip
                  x-small
                  class="font-weight-bold text-uppercase"
                  :color="getStatusColor(item.MetalStatus).bg"
                  :text-color="getStatusColor(item.MetalStatus).text"
                  style="height: 19px; font-size: 0.68rem;"
                >
                  <v-icon left style="font-size: 11px; margin-right: 2px;">{{ getStatusColor(item.MetalStatus).icon }}</v-icon>
                  {{ formatStatusText(item.MetalStatus) }}
                </v-chip>
              </div>
            </div>

            <!-- Si NO Requiere Análisis -->
            <div v-else class="grey--text text--darken-2 font-weight-medium mt-1" style="font-size: 0.72rem;">
              <v-icon x-small color="grey darken-1" class="mr-1">mdi-account-check-outline</v-icon>
              Aprobación Proveedor
            </div>
          </div>
        </template>

        <!-- Mercados No Aptos (Consolidado) -->
        <template v-slot:[`item.FailedMarkets`]="{ item }">
          <div v-if="item.FailedMarkets" style="min-width: 140px; max-width: 200px;">
            <v-chip
              v-for="(market, idx) in parseMarketList(item.FailedMarkets).slice(0, 3)"
              :key="idx"
              x-small
              color="red lighten-5"
              text-color="red darken-3"
              class="font-weight-bold mb-1 mr-1"
            >
              {{ market }}
            </v-chip>
            <v-btn
              v-if="parseMarketList(item.FailedMarkets).length > 3"
              x-small
              color="red darken-1"
              dark
              class="text-capitalize font-weight-bold px-2 mb-1 rounded-pill elevation-1"
              @click="openMarketsModal('Países NO Aptos para Exportación', item.FailedMarkets, 'red', item)"
            >
              +{{ parseMarketList(item.FailedMarkets).length - 3 }} más
            </v-btn>
          </div>
          <span v-else class="grey--text text--lighten-1 font-italic">Ninguno</span>
        </template>

        <!-- Países Aptos (Consolidado) -->
        <template v-slot:[`item.ApprovedMarkets`]="{ item }">
          <div v-if="item.ApprovedMarkets" style="min-width: 200px; max-width: 270px;">
            <v-chip
              v-for="(market, idx) in parseMarketList(item.ApprovedMarkets).slice(0, 3)"
              :key="idx"
              x-small
              color="green lighten-5"
              text-color="green darken-3"
              class="font-weight-bold mb-1 mr-1"
            >
              {{ market }}
            </v-chip>
            <v-btn
              v-if="parseMarketList(item.ApprovedMarkets).length > 3"
              x-small
              color="green darken-2"
              dark
              class="text-capitalize font-weight-bold px-2 mb-1 rounded-pill elevation-1"
              @click="openMarketsModal('Países Aptos para Exportación', item.ApprovedMarkets, 'green', item)"
            >
              +{{ parseMarketList(item.ApprovedMarkets).length - 3 }} más
            </v-btn>
          </div>
          <span v-else class="grey--text text--lighten-1 font-italic">Ninguno</span>
        </template>

        <!-- NUEVA COLUMNA: Mercados No Aptos (Evaluación de Sustancias Prohibidas) -->
        <template v-slot:[`item.ProhibitedMarkets`]="{ item }">
          <div class="d-flex align-center flex-wrap" style="min-width: 170px; max-width: 280px;">
            <!-- Si tiene mercados no aptos registrados en ProhibitedMarkets -->
            <template v-if="parseMarketList(item.ProhibitedMarkets || item.prohibitedMarkets).length > 0">
              <v-chip
                v-for="(market, idx) in parseMarketList(item.ProhibitedMarkets || item.prohibitedMarkets).slice(0, 3)"
                :key="idx"
                x-small
                color="red lighten-5"
                text-color="red darken-3"
                class="font-weight-bold mb-1 mr-1"
              >
                {{ market }}
              </v-chip>
              <v-chip
                v-if="parseMarketList(item.ProhibitedMarkets || item.prohibitedMarkets).length > 3"
                x-small
                color="red darken-1"
                dark
                class="font-weight-bold mb-1 mr-1"
                style="cursor: pointer"
                @click="openMarketsModal('Mercados NO Aptos por Sustancias Prohibidas', item.ProhibitedMarkets || item.prohibitedMarkets, 'red', item)"
              >
                +{{ parseMarketList(item.ProhibitedMarkets || item.prohibitedMarkets).length - 3 }} más
              </v-chip>

              <!-- Botón para Admin/Encargado al costadito para reevaluar o editar -->
              <v-btn
                v-if="isUserAdmin && item.SuaID"
                x-small
                outlined
                color="red darken-2"
                class="text-capitalize font-weight-medium rounded-pill px-2 mb-1 ml-1"
                title="Editar / Evaluar Mercados No Aptos"
                @click.stop="openProhibitedMarketsEvaluation(item)"
              >
                <v-icon left x-small>mdi-pencil</v-icon>
                Editar
              </v-btn>
            </template>

            <!-- Si NO tiene mercados no aptos registrados aún -->
            <template v-else>
              <v-btn
                v-if="isUserAdmin && item.SuaID"
                x-small
                outlined
                color="red darken-2"
                class="text-capitalize font-weight-medium rounded-pill px-2 mb-1"
                title="Evaluar y registrar mercados no aptos por sustancias prohibidas"
                @click.stop="openProhibitedMarketsEvaluation(item)"
              >
                <v-icon left x-small>mdi-shield-alert-outline</v-icon>
                Evaluar No Aptos
              </v-btn>
              <span v-else class="grey--text text--lighten-1 font-italic">Sin evaluar</span>
            </template>
          </div>
        </template>

        <!-- Observaciones -->
        <template v-slot:[`item.ConsolidatedObservation`]="{ item }">
          <!-- Si NO se solicitó análisis (RequiresAnalysis == 0) -->
          <template v-if="item.RequiresAnalysis === 0 || item.RequiresAnalysis === '0' || item.RequiresAnalysis === false">
            <div
              v-if="item.ObservationApproval && String(item.ObservationApproval).trim() !== ''"
              style="min-width: 260px; font-size: 0.8rem; line-height: 1.35;"
              class="grey--text text--darken-3"
            >
              {{ item.ObservationApproval }}
            </div>
            <span v-else class="grey--text text--lighten-1 font-italic">Sin observaciones</span>
          </template>

          <!-- Si SÍ se solicitó análisis (RequiresAnalysis == 1) -->
          <template v-else>
            <div
              v-if="item.PesticideObservationApproval || item.MetalObservationApproval || item.ObservationApproval"
              style="min-width: 280px; font-size: 0.8rem; line-height: 1.35;"
            >
              <div v-if="item.PesticideObservationApproval" class="mb-1">
                <span class="font-weight-bold purple--text text--darken-3">Pesticidas:</span>
                <span class="grey--text text--darken-3 ml-1">{{ item.PesticideObservationApproval }}</span>
              </div>
              <div v-if="item.MetalObservationApproval" class="mb-1">
                <span class="font-weight-bold cyan--text text--darken-4">Metales:</span>
                <span class="grey--text text--darken-3 ml-1">{{ item.MetalObservationApproval }}</span>
              </div>
              <div v-if="item.ObservationApproval && !item.PesticideObservationApproval && !item.MetalObservationApproval">
                <span class="grey--text text--darken-3">{{ item.ObservationApproval }}</span>
              </div>
            </div>
            <span v-else class="grey--text text--lighten-1 font-italic">Sin observaciones</span>
          </template>
        </template>
      </v-data-table>
    </v-card>

    <!-- Modal Detalle Completo de Países -->
    <v-dialog v-model="dialogMarketsModal" max-width="520px">
      <v-card class="rounded-lg">
        <v-card-title
          class="headline py-3 px-4 d-flex align-center justify-space-between white--text"
          :class="marketsModalColor === 'green' ? 'green darken-2' : 'red darken-2'"
        >
          <div class="d-flex align-center">
            <v-icon color="white" left>{{ marketsModalColor === 'green' ? 'mdi-earth' : 'mdi-earth-off' }}</v-icon>
            <span style="font-size: 1.05rem; font-weight: 600;">{{ marketsModalTitle }}</span>
          </div>
          <v-btn icon dark @click="dialogMarketsModal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-4" v-if="selectedMarketsItem">
          <div class="grey lighten-4 pa-3 rounded-lg border mb-3">
            <div class="caption grey--text text--darken-2 d-block">
              Fundo / Lote: <strong class="black--text">{{ selectedMarketsItem.FagName }} (ID Lote: {{ selectedMarketsItem.FltID }})</strong>
            </div>
            <div class="caption grey--text text--darken-2 d-block">
              Productor: <strong class="black--text">{{ selectedMarketsItem.PrdCardName }}</strong>
            </div>
            <div class="caption grey--text text--darken-2 d-block">
              Campaña: <strong class="black--text">{{ selectedMarketsItem.CmaName }}</strong> | Variedad: <strong class="black--text">{{ selectedMarketsItem.VrtDescription }}</strong>
            </div>
          </div>

          <div class="caption font-weight-bold grey--text text--darken-3 mb-2">
            Lista Completa de Países ({{ selectedMarketsList.length }}):
          </div>

          <div class="d-flex flex-wrap pa-2 grey lighten-5 rounded-lg border" style="max-height: 280px; overflow-y: auto;">
            <v-chip
              v-for="(m, idx) in selectedMarketsList"
              :key="idx"
              small
              :color="marketsModalColor === 'green' ? 'green lighten-5' : 'red lighten-5'"
              :text-color="marketsModalColor === 'green' ? 'green darken-3' : 'red darken-3'"
              class="font-weight-bold ma-1"
            >
              <v-icon left x-small :color="marketsModalColor === 'green' ? 'green darken-2' : 'red darken-2'">
                {{ marketsModalColor === 'green' ? 'mdi-check-circle' : 'mdi-close-circle' }}
              </v-icon>
              {{ m }}
            </v-chip>
          </div>
        </v-card-text>

        <v-card-actions class="pa-3 grey lighten-3">
          <v-spacer></v-spacer>
          <v-btn text @click="dialogMarketsModal = false" class="text-capitalize font-weight-bold">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal Evaluación de Mercados No Aptos por Sustancias Prohibidas -->
    <v-dialog v-model="dialogProhibitedMarkets" max-width="720px" persistent>
      <v-card class="rounded-xl overflow-hidden elevation-8">
        <!-- Título Ejecutivo Corporativo -->
        <v-card-title class="py-3 px-5 d-flex align-center justify-space-between modal-header-dark">
          <div class="d-flex align-center">
            <v-icon color="#f87171" left>mdi-shield-alert-outline</v-icon>
            <div>
              <div class="text-subtitle-1 font-weight-bold white--text line-height-tight">
                Evaluación de Mercados No Aptos por Sustancia
              </div>
              <div class="caption grey--text text--lighten-1">
                Revisión técnica de sustancias activas restringidas por mercado
              </div>
            </div>
          </div>
          <v-btn icon dark small @click="dialogProhibitedMarkets = false" :disabled="savingProhibited">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <!-- Cabecera Informativa del Lote -->
        <v-card-text class="pa-4 pb-2" v-if="currentEvaluationItem">
          <div class="modal-info-panel pa-3 rounded-lg mb-3">
            <v-row dense>
              <v-col cols="12" sm="6" class="py-1">
                <span class="info-label">Lote:</span>
                <span class="info-value">{{ currentEvaluationItem.FltID || '-' }}</span>
                <span class="info-label ml-3">Fundo:</span>
                <span class="info-value">{{ currentEvaluationItem.FagName || '-' }}</span>
              </v-col>
              <v-col cols="12" sm="6" class="py-1">
                <span class="info-label">Productor:</span>
                <span class="info-value">{{ currentEvaluationItem.PrdCardName || '-' }}</span>
              </v-col>
              <v-col cols="12" sm="6" class="py-1">
                <span class="info-label">Campaña:</span>
                <span class="info-value">{{ currentEvaluationItem.CmaName || '-' }}</span>
              </v-col>
              <v-col cols="12" sm="6" class="py-1">
                <span class="info-label">Cultivo / Var:</span>
                <span class="info-value">{{ currentEvaluationItem.TypeCultiveName || '-' }} - {{ currentEvaluationItem.VrtDescription || '-' }}</span>
              </v-col>
            </v-row>
          </div>

          <div class="modal-instruction-box pa-3 rounded-lg mb-3 d-flex align-start">
            <v-icon color="#0284c7" small class="mr-2 mt-0">mdi-information</v-icon>
            <div class="caption text-sky-dark">
              A continuación se listan los mercados evaluados para este lote. Aquellos con sustancias prohibidas o que exceden LMR aparecen resaltados. 
              <strong>Marque los mercados que deben quedar registrados como NO APTOS</strong> para exportación.
            </div>
          </div>

          <!-- Loading state -->
          <div v-if="loadingProhibited" class="d-flex flex-column align-center justify-center py-6">
            <v-progress-circular indeterminate color="primary" size="36" class="mb-2"></v-progress-circular>
            <span class="text-caption grey--text text--darken-2">Cargando sustancias prohibidas por mercado...</span>
          </div>

          <!-- Empty state -->
          <div v-else-if="prohibitedMarketsList.length === 0" class="text-center py-6 grey lighten-5 rounded-lg border">
            <v-icon large color="grey darken-1" class="mb-2">mdi-check-circle-outline</v-icon>
            <div class="text-body-2 font-weight-bold grey--text text--darken-3">
              No se detectaron mercados para evaluar
            </div>
            <div class="text-caption grey--text text--darken-1">
              Este lote no tiene destinos registrados en los análisis evaluados.
            </div>
          </div>

          <!-- Lista de Mercados con Selección -->
          <div v-else>
            <div class="d-flex align-center justify-space-between mb-2">
              <span class="caption font-weight-bold grey--text text--darken-3">
                Mercados Evaluados ({{ prohibitedMarketsList.length }}):
              </span>
              <div>
                <v-btn
                  x-small
                  text
                  color="primary"
                  class="text-capitalize font-weight-bold mr-1"
                  @click="selectAllWithSubstances"
                  title="Marcar como No Aptos solo los mercados con sustancias prohibidas"
                >
                  Marcar Con Restricción
                </v-btn>
                <v-btn
                  x-small
                  text
                  color="grey darken-2"
                  class="text-capitalize font-weight-bold"
                  @click="deselectAllProhibitedMarkets"
                >
                  Desmarcar Todos
                </v-btn>
              </div>
            </div>

            <div class="modal-table-container rounded-lg border overflow-hidden">
              <v-simple-table dense class="elevation-0">
                <template v-slot:default>
                  <thead>
                    <tr class="modal-table-header">
                      <th style="width: 50px;" class="text-center">No Apto</th>
                      <th class="text-left font-weight-bold" style="width: 140px;">Mercado / Destino</th>
                      <th class="text-left font-weight-bold">Sustancias Restringidas Detectadas</th>
                      <th style="width: 110px;" class="text-center font-weight-bold">Estado</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(mkt, idx) in prohibitedMarketsList"
                      :key="`mkt-${getMarketId(mkt) || idx}`"
                      :class="selectedMarketIds.includes(getMarketId(mkt)) ? 'row-prohibited-selected' : 'row-prohibited-compliant'"
                    >
                      <td class="text-center">
                        <v-checkbox
                          v-model="selectedMarketIds"
                          :value="getMarketId(mkt)"
                          color="error"
                          dense
                          hide-details
                          class="ma-0 pa-0 d-inline-flex"
                        />
                      </td>
                      <td class="font-weight-bold text-caption text-slate-800">
                        <v-icon x-small :color="selectedMarketIds.includes(getMarketId(mkt)) ? '#e11d48' : '#64748b'" class="mr-1">
                          {{ selectedMarketIds.includes(getMarketId(mkt)) ? 'mdi-earth-remove' : 'mdi-earth' }}
                        </v-icon>
                        {{ getMarketDescription(mkt) }}
                      </td>
                      <td class="text-caption py-2">
                        <!-- Si tiene sustancias restringidas detectadas -->
                        <template v-if="hasProhibitedSubstances(mkt)">
                          <div class="d-flex flex-wrap gap-1">
                            <span
                              v-for="(sub, sIdx) in parseSubstancesList(getMarketSubstances(mkt))"
                              :key="`sub-${sIdx}`"
                              class="substance-chip-restricted"
                            >
                              {{ sub }}
                            </span>
                          </div>
                        </template>
                        <!-- Si NO tiene sustancias restringidas (NULL) -->
                        <template v-else>
                          <span class="substance-chip-ok">
                            <v-icon x-small color="#16a34a" class="mr-1">mdi-check-circle-outline</v-icon>
                            Cumple (Sin sustancias prohibidas)
                          </span>
                        </template>
                      </td>
                      <td class="text-center py-2">
                        <span
                          v-if="selectedMarketIds.includes(getMarketId(mkt))"
                          class="status-chip-blocked"
                        >
                          <v-icon x-small color="#b91c1c" class="mr-1">mdi-close-circle</v-icon>
                          NO APTO
                        </span>
                        <span
                          v-else
                          class="status-chip-allowed"
                        >
                          <v-icon x-small color="#15803d" class="mr-1">mdi-check-circle</v-icon>
                          APTO
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>

            <div class="mt-2 text-right">
              <span class="caption font-weight-bold grey--text text--darken-2">
                Seleccionados como No Aptos: <strong class="red--text text--darken-3">{{ selectedMarketIds.length }}</strong> de {{ prohibitedMarketsList.length }}
              </span>
            </div>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <!-- Acciones del Modal -->
        <v-card-actions class="pa-3 modal-actions-footer">
          <v-spacer></v-spacer>
          <v-btn
            text
            color="grey darken-2"
            class="text-capitalize font-weight-bold mr-2 text-none"
            @click="dialogProhibitedMarkets = false"
            :disabled="savingProhibited"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="#dc2626"
            class="text-capitalize font-weight-bold white--text px-4 rounded-lg elevation-0 btn-save-prohibited text-none"
            :loading="savingProhibited"
            :disabled="loadingProhibited || prohibitedMarketsList.length === 0"
            @click="saveProhibitedMarkets"
          >
            <v-icon left small>mdi-content-save</v-icon>
            Guardar Mercados No Aptos
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _sRawAnalysisService from "@/services/Technicalassistance/TasRawMaterialAnalysisService.js";
import _sSupplierApprovalsService from "@/services/Technicalassistance/TasSupplierApprovalsService.js";
import SSelectCampaignArea from "@/components/Utils/SSelectCampaignArea.vue";
import SSelectLot from "@/components/HarvestSchedule/SSelectLot.vue";
import SSelectDefinition from "@/components/Utils/SSelectDefinition.vue";
import SDate from "@/components/Utils/SDate.vue";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import moment from "moment";

export default {
  name: "RawMaterialApprovalReport",
  components: {
    SSelectCampaignArea,
    SSelectLot,
    SSelectDefinition,
    SDate,
  },
  data: () => ({
    loading: false,
    searchText: "",
    filters: {
      CmaID: null,
      FltID: null,
      TypeCultive: null,
      TypeSupplier: null,
      TypeProcessingPlant: null,
      BeginDate: null,
      EndDate: null,
    },
    approvalList: [],
    dialogMarketsModal: false,
    marketsModalTitle: "",
    marketsModalColor: "green",
    selectedMarketsList: [],
    selectedMarketsItem: null,
    // Modal de evaluación de mercados no aptos por sustancias prohibidas
    dialogProhibitedMarkets: false,
    loadingProhibited: false,
    savingProhibited: false,
    currentEvaluationItem: null,
    prohibitedMarketsList: [],
    selectedMarketIds: [],
    headers: [
      { text: "Lote / Fundo", value: "FltID", align: "start", sortable: true, width: "110px" },
      { text: "Campaña", value: "CmaName", sortable: true, width: "140px" },
      { text: "Productor", value: "PrdCardName", sortable: true, width: "180px" },
      { text: "Tipo Proveedor", value: "TypeSupplierName", sortable: true, width: "130px" },
      { text: "Variedad", value: "VrtDescription", sortable: true, width: "110px" },
      { text: "Cultivo", value: "TypeCultiveName", sortable: true, width: "100px" },
      { text: "Zona", value: "ZonIDText", sortable: true, width: "130px" },
      { text: "Certificación", value: "Certification", sortable: false, width: "200px" },
      { text: "Req. Análisis", value: "RequiresAnalysis", sortable: true, width: "120px" },
      { text: "Fec. Análisis Metal", value: "MetalAnalysisDate", sortable: true, width: "130px" },
      { text: "Fec. Venc. Metal", value: "MetalAnalysisExpirationDate", sortable: true, width: "130px" },
      { text: "Vigencia Metal", value: "MetalAnalysisValidity", sortable: true, width: "120px" },
      { text: "Plomo (ppm)", value: "PLOMO", sortable: true, width: "110px" },
      { text: "Cadmio (ppm)", value: "CADMIO", sortable: true, width: "110px" },
      { text: "Níquel (ppm)", value: "NIQUEL", sortable: true, width: "110px" },
      { text: "Fec. Análisis Pesticida", value: "PesticideAnalysisDate", sortable: true, width: "130px" },
      { text: "Fec. Venc. Pesticida", value: "PesticideAnalysisExpirationDate", sortable: true, width: "130px" },
      { text: "Vigencia Pesticida", value: "PesticideAnalysisValidity", sortable: true, width: "120px" },
      { text: "Residuos / Trazas", value: "ResiduosTrazas", sortable: false, width: "200px" },
      { text: "Positivos", value: "Positivos", sortable: false, width: "200px" },
      { text: "Dictamen Final", value: "ConsolidatedStatus", sortable: true, width: "215px" },
      { text: "Mercados No Aptos", value: "ProhibitedMarkets", sortable: false, width: "220px" },
      { text: "Países No Aptos", value: "FailedMarkets", sortable: false, width: "170px" },
      { text: "Países Aptos", value: "ApprovedMarkets", sortable: false, width: "300px" },
      { text: "Observaciones", value: "ConsolidatedObservation", sortable: false, width: "320px" },
    ],
  }),

  computed: {
    filteredList() {
      let list = this.approvalList;

      if (this.filters.TypeSupplier) {
        list = list.filter((item) => {
          if (item.TypeSupplier !== undefined && item.TypeSupplier !== null) {
            return Number(item.TypeSupplier) === Number(this.filters.TypeSupplier);
          }
          return true;
        });
      }

      if (this.filters.TypeProcessingPlant) {
        list = list.filter((item) => {
          if (item.TypeProcessingPlant !== undefined && item.TypeProcessingPlant !== null) {
            return Number(item.TypeProcessingPlant) === Number(this.filters.TypeProcessingPlant);
          }
          if (item.TypeDestination !== undefined && item.TypeDestination !== null) {
            return Number(item.TypeDestination) === Number(this.filters.TypeProcessingPlant);
          }
          return true;
        });
      }

      if (!this.searchText || this.searchText.trim() === "") {
        return list;
      }
      const q = this.searchText.trim().toLowerCase();
      return list.filter((item) => {
        return (
          String(item.FltID || "").toLowerCase().includes(q) ||
          String(item.CmaName || "").toLowerCase().includes(q) ||
          String(item.PrdCardName || "").toLowerCase().includes(q) ||
          String(item.TypeSupplierName || "").toLowerCase().includes(q) ||
          String(item.VrtDescription || "").toLowerCase().includes(q) ||
          String(item.TypeCultiveName || "").toLowerCase().includes(q) ||
          String(item.ZonIDText || "").toLowerCase().includes(q) ||
          String(item.Certification || "").toLowerCase().includes(q) ||
          String(item.MetalAnalysisValidity || "").toLowerCase().includes(q) ||
          String(item.PesticideAnalysisValidity || "").toLowerCase().includes(q) ||
          String(item.PesticideStatus || "").toLowerCase().includes(q) ||
          String(item.MetalStatus || "").toLowerCase().includes(q) ||
          String(item.SupplierApprovalStatus || "").toLowerCase().includes(q) ||
          String(item.ResiduosTrazas || "").toLowerCase().includes(q) ||
          String(item.Positivos || "").toLowerCase().includes(q) ||
          String(item.ConsolidatedStatus || "").toLowerCase().includes(q) ||
          String(item.FailedMarkets || "").toLowerCase().includes(q) ||
          String(item.ApprovedMarkets || "").toLowerCase().includes(q) ||
          String(item.ProhibitedMarkets || "").toLowerCase().includes(q) ||
          String(item.ConsolidatedFailedMarkets || "").toLowerCase().includes(q) ||
          String(item.ConsolidatedApprovedMarkets || "").toLowerCase().includes(q) ||
          String(item.ObservationApproval || "").toLowerCase().includes(q) ||
          String(item.ConsolidatedObservation || "").toLowerCase().includes(q)
        );
      });
    },


    isUserAdmin() {
      try {
        const sec = this.$fun.getSecurity ? this.$fun.getSecurity() : null;
        if (sec && (sec.IsLevelAdmin || sec.IsAdmin)) return true;
        if (typeof this.$fun.isAdmin === "function") {
          const res = this.$fun.isAdmin();
          if (res) return true;
        }
        const usr = this.$fun.getUserInfo ? this.$fun.getUserInfo() : null;
        if (usr && (usr.IsAdmin || usr.IsLevelAdmin || (usr.UsrName && usr.UsrName.toLowerCase().includes("admin")))) {
          return true;
        }
      } catch (e) {
        // Fallback
      }
      const usrLogin = String(this.$fun.getUserInfoLogin ? this.$fun.getUserInfoLogin() : "").toLowerCase();
      if (usrLogin.includes("admin") || usrLogin.includes("programador")) return true;
      return false;
    },
  },

  methods: {
    async loadApprovalReport() {
      this.loading = true;
      try {
        const userId = this.$fun.getUserID();
        const filterPayload = {
          CmaID: this.filters.CmaID || null,
          FltID: this.filters.FltID || null,
          TypeCultive: this.filters.TypeCultive || null,
          TypeSupplier: this.filters.TypeSupplier || null,
          TypeProcessingPlant: this.filters.TypeProcessingPlant || null,
          BeginDate: this.filters.BeginDate ? moment(this.filters.BeginDate).format("YYYY-MM-DD") : null,
          EndDate: this.filters.EndDate ? moment(this.filters.EndDate).format("YYYY-MM-DD") : null,
        };

        const resp = await _sRawAnalysisService.rawMaterialApprovalReport(filterPayload, userId);
        if (resp && resp.data && Array.isArray(resp.data)) {
          this.approvalList = resp.data.map((item) => {
            const isNoAnalysis = item.RequiresAnalysis === 0 || item.RequiresAnalysis === "0" || item.RequiresAnalysis === false;

            const consolidatedStatus = isNoAnalysis
              ? this.formatStatusText(item.SupplierApprovalStatus || "PENDIENTE")
              : this.calcConsolidatedStatus(item.PesticideStatus, item.MetalStatus);

            const failedMarkets = (item.FailedMarkets !== undefined && item.FailedMarkets !== null && String(item.FailedMarkets).trim() !== "")
              ? item.FailedMarkets
              : this.calcConsolidatedFailedMarkets(item.PesticideFailedMarkets, item.MetalFailedMarkets);

            const approvedMarkets = (item.ApprovedMarkets !== undefined && item.ApprovedMarkets !== null && String(item.ApprovedMarkets).trim() !== "")
              ? item.ApprovedMarkets
              : this.calcConsolidatedApprovedMarkets(
                  item.PesticideApprovedMarkets,
                  item.MetalApprovedMarkets,
                  item.PesticideFailedMarkets,
                  item.MetalFailedMarkets
                );

            const consolidatedObs = isNoAnalysis
              ? (item.ObservationApproval || "")
              : (this.calcConsolidatedObservation(item.PesticideObservationApproval, item.MetalObservationApproval) || item.ObservationApproval || "");

            return {
              ...item,
              ProhibitedMarkets: item.ProhibitedMarkets !== undefined && item.ProhibitedMarkets !== null ? item.ProhibitedMarkets : (item.prohibitedMarkets || ""),
              ConsolidatedStatus: consolidatedStatus,
              FailedMarkets: failedMarkets,
              ApprovedMarkets: approvedMarkets,
              ConsolidatedFailedMarkets: failedMarkets,
              ConsolidatedApprovedMarkets: approvedMarkets,
              ConsolidatedObservation: consolidatedObs,
            };
          });
        } else {
          this.approvalList = [];
        }
      } catch (error) {
        console.error("Error al consultar reporte de aprobación:", error);
        this.$fun.alert("Error al consultar el reporte de aprobación de lotes", "error");
      } finally {
        this.loading = false;
      }
    },

    calcConsolidatedStatus(pestStatus, metalStatus) {
      const p = String(pestStatus || "").toUpperCase().trim();
      const m = String(metalStatus || "").toUpperCase().trim();

      const isPestRej = p === "5" || p.includes("RECHAZAD") || p.includes("NO CONFORME");
      const isMetRej = m === "5" || m.includes("RECHAZAD") || m.includes("NO CONFORME");

      const isPestRest = p === "4" || p === "3" || p.includes("RESTRING") || p.includes("OBSERVAD");
      const isMetRest = m === "4" || m === "3" || m.includes("RESTRING") || m.includes("OBSERVAD");

      const isPestApp = p === "2" || p.includes("LIBRE") || p.includes("APROBADO");
      const isMetApp = m === "2" || m.includes("LIBRE") || m.includes("APROBADO");

      // 1. Si alguno es rechazado o no conforme -> NO CONFORME
      if (isPestRej || isMetRej) {
        return "NO CONFORME";
      }

      // 2. Si alguno es restringido u observado -> RESTRINGIDO
      if (isPestRest || isMetRest) {
        return "RESTRINGIDO";
      }

      // 3. Si ambos están aprobados -> APROBADO
      if (isPestApp && isMetApp) {
        return "APROBADO";
      }

      // 4. Si solo uno fue evaluado y está aprobado -> APROBADO
      if (isPestApp || isMetApp) {
        return "APROBADO";
      }

      // 5. Pendiente
      return "PENDIENTE";
    },

    formatStatusText(statusName) {
      if (statusName === 2 || statusName === "2") return "APROBADO";
      if (statusName === 3 || statusName === "3") return "OBSERVADO";
      if (statusName === 4 || statusName === "4") return "RESTRINGUIDO";
      if (statusName === 5 || statusName === "5") return "NO CONFORME";
      if (statusName === 1 || statusName === "1") return "PENDIENTE";
      return statusName || "PENDIENTE";
    },

    parseMarketList(val) {
      if (!val || val === null || val === undefined) return [];
      if (Array.isArray(val)) return val;
      const s = String(val).trim();
      if (s === "" || s.toUpperCase() === "NULL") return [];
      return s
        .split(",")
        .map((m) => m.trim())
        .filter((m) => m.length > 0 && m.toUpperCase() !== "NULL");
    },

    calcConsolidatedFailedMarkets(pestFailed, metalFailed) {
      const pList = this.parseMarketList(pestFailed);
      const mList = this.parseMarketList(metalFailed);
      const union = Array.from(new Set([...pList, ...mList]));
      return union.join(", ");
    },

    calcConsolidatedApprovedMarkets(pestApproved, metalApproved, pestFailed, metalFailed) {
      const pApp = this.parseMarketList(pestApproved);
      const mApp = this.parseMarketList(metalApproved);
      const failed = Array.from(
        new Set([...this.parseMarketList(pestFailed), ...this.parseMarketList(metalFailed)])
      );

      let approved = [];
      if (pApp.length > 0 && mApp.length > 0) {
        // Intersección de ambos
        approved = pApp.filter((x) => mApp.includes(x));
      } else if (pApp.length > 0) {
        approved = pApp;
      } else if (mApp.length > 0) {
        approved = mApp;
      }

      // Excluir cualquier mercado que haya fallado
      const finalApproved = approved.filter((x) => !failed.includes(x));
      return Array.from(new Set(finalApproved)).join(", ");
    },

    calcConsolidatedObservation(pestObs, metObs) {
      const p = pestObs && String(pestObs).trim() !== "" && String(pestObs).trim().toUpperCase() !== "NULL" ? String(pestObs).trim() : null;
      const m = metObs && String(metObs).trim() !== "" && String(metObs).trim().toUpperCase() !== "NULL" ? String(metObs).trim() : null;

      if (p && m) {
        if (p === m) return p;
        return `[Pesticidas] ${p}\n[Metales] ${m}`;
      }
      if (p) return p;
      if (m) return m;
      return "";
    },

    formatDate(dateStr) {
      if (!dateStr) return "-";
      return moment(dateStr).format("DD/MM/YYYY");
    },

    formatDecimal(val) {
      if (val === null || val === undefined || isNaN(val)) return "-";
      return Number(val).toFixed(6);
    },

    openMarketsModal(title, marketsStr, color, item) {
      this.marketsModalTitle = title;
      this.marketsModalColor = color;
      this.selectedMarketsItem = item;
      this.selectedMarketsList = this.parseMarketList(marketsStr);
      this.dialogMarketsModal = true;
    },

    getMarketSubstances(mkt) {
      if (!mkt) return "";
      const val = mkt.Substances !== undefined ? mkt.Substances : (mkt.substances !== undefined ? mkt.substances : "");
      if (!val || val === null || val === undefined) return "";
      const s = String(val).trim();
      if (s === "" || s.toUpperCase() === "NULL") return "";
      return s;
    },

    getMarketDescription(mkt) {
      if (!mkt) return "-";
      return mkt.Description || mkt.description || mkt.MktName || mkt.mktName || "-";
    },

    getMarketId(mkt) {
      if (!mkt) return null;
      const id = mkt.MktID !== undefined ? mkt.MktID : mkt.mktID;
      return id !== undefined && id !== null ? Number(id) : null;
    },

    getMarketSamId(mkt) {
      if (!mkt) return null;
      const id = mkt.SamID !== undefined ? mkt.SamID : mkt.samID;
      return id !== undefined && id !== null ? Number(id) : null;
    },

    getMarketSuaId(mkt) {
      if (!mkt) return null;
      const id = mkt.SuaID !== undefined ? mkt.SuaID : mkt.suaID;
      return id !== undefined && id !== null ? Number(id) : null;
    },

    hasProhibitedSubstances(mkt) {
      return this.getMarketSubstances(mkt).length > 0;
    },

    parseSubstancesList(subStr) {
      if (!subStr) return [];
      return String(subStr)
        .split(",")
        .map((s) => s.trim())
        .filter((s) => s.length > 0 && s.toUpperCase() !== "NULL");
    },

    async openProhibitedMarketsEvaluation(item) {
      if (!item.SuaID) {
        this.$fun.alert("Este lote no cuenta con un ID de Aprobación de Proveedor (SuaID) para evaluar mercados", "warning");
        return;
      }
      this.currentEvaluationItem = item;
      this.prohibitedMarketsList = [];
      this.selectedMarketIds = [];
      this.dialogProhibitedMarkets = true;
      this.loadingProhibited = true;

      try {
        const userId = this.$fun.getUserID();
        const resp = await _sSupplierApprovalsService.ProhibitedMarketsBySubstanceList(item.SuaID, userId);
        if (resp && resp.data && Array.isArray(resp.data)) {
          this.prohibitedMarketsList = resp.data;

          const preSelected = [];
          const hasAnySaved = resp.data.some((m) => {
            const samId = this.getMarketSamId(m);
            const suaId = this.getMarketSuaId(m);
            return samId !== null && Number(samId) > 0 && Number(suaId) === Number(item.SuaID);
          });

          resp.data.forEach((m) => {
            const mktId = this.getMarketId(m);
            const samId = this.getMarketSamId(m);
            const suaId = this.getMarketSuaId(m);
            const hasSubs = this.hasProhibitedSubstances(m);

            if (hasAnySaved) {
              // Si ya se guardó previamente en BD para este SuaID, pre-seleccionar
              if (samId !== null && Number(samId) > 0 && Number(suaId) === Number(item.SuaID)) {
                preSelected.push(mktId);
              }
            } else {
              // Si es la primera vez (SamID es null):
              // REGLA: SOLO marcar por defecto aquellos con sustancias prohibidas (hasSubs == true)
              if (hasSubs) {
                preSelected.push(mktId);
              }
            }
          });

          this.selectedMarketIds = preSelected;
        } else {
          this.prohibitedMarketsList = [];
        }
      } catch (error) {
        console.error("Error al cargar sustancias prohibidas por mercado:", error);
        this.$fun.alert("Error al consultar sustancias prohibidas: " + (error.message || error), "error");
      } finally {
        this.loadingProhibited = false;
      }
    },

    selectAllWithSubstances() {
      // Marcar únicamente los mercados que presentan sustancias restringidas
      this.selectedMarketIds = this.prohibitedMarketsList
        .filter((m) => this.hasProhibitedSubstances(m))
        .map((m) => this.getMarketId(m));
    },

    selectAllProhibitedMarkets() {
      this.selectedMarketIds = this.prohibitedMarketsList.map((m) => this.getMarketId(m));
    },

    deselectAllProhibitedMarkets() {
      this.selectedMarketIds = [];
    },

    async saveProhibitedMarkets() {
      this.savingProhibited = true;
      try {
        const userId = this.$fun.getUserID();
        const suaId = this.currentEvaluationItem.SuaID;

        const payloadMarkets = this.prohibitedMarketsList.map((m) => {
          const samId = this.getMarketSamId(m) || 0;
          const mktId = this.getMarketId(m);
          const isChecked = this.selectedMarketIds.includes(mktId);
          return {
            SamID: samId,
            MktID: mktId,
            SecStatus: isChecked ? 1 : 0,
          };
        });

        const resp = await _sSupplierApprovalsService.RegisterProhibitedMarkets(
          suaId,
          payloadMarkets,
          userId
        );

        if (resp && (resp.status === 200 || resp.data)) {
          this.$fun.alert("Mercados no aptos registrados correctamente", "success");
          this.dialogProhibitedMarkets = false;

          // Actualizar inmediatamente en memoria para la celda de esta fila
          const selectedNames = this.prohibitedMarketsList
            .filter((m) => this.selectedMarketIds.includes(this.getMarketId(m)))
            .map((m) => this.getMarketDescription(m));

          this.$set(this.currentEvaluationItem, "ProhibitedMarkets", selectedNames.join(", "));

          // Recargar el reporte completo para refrescar
          this.loadApprovalReport();
        } else {
          this.$fun.alert("Se enviaron los datos al servidor", "success");
          this.dialogProhibitedMarkets = false;
        }
      } catch (error) {
        console.error("Error al registrar mercados no aptos:", error);
        this.$fun.alert("Error al registrar mercados no aptos: " + (error.message || error), "error");
      } finally {
        this.savingProhibited = false;
      }
    },

    parseCertifications(certStr) {
      if (!certStr) return [];
      return certStr.split("|").map((c) => c.trim()).filter((c) => c.length > 0);
    },

    getValidityColor(val) {
      const st = String(val || "").toUpperCase();
      if (st.includes("VIGENTE")) {
        return { bg: "green lighten-5", text: "green darken-3" };
      }
      if (st.includes("VENCID") || st.includes("CADUC")) {
        return { bg: "red lighten-5", text: "red darken-3" };
      }
      return { bg: "grey lighten-4", text: "grey darken-3" };
    },

    getStatusColor(statusName) {
      const st = String(statusName || "").toUpperCase().trim();
      if (st === "2" || st.includes("LIBRE") || st === "APROBADO") {
        return { bg: "green lighten-5", text: "green darken-3", icon: "mdi-check-circle" };
      }
      if (st.includes("OBSERVAD")) {
        return { bg: "purple lighten-5", text: "purple darken-3", icon: "mdi-clock-alert-outline" };
      }
      if (st.includes("RESTRING")) {
        return { bg: "orange lighten-5", text: "orange darken-3", icon: "mdi-shield-alert-outline" };
      }
      if (st === "4" || st === "5" || st.includes("RECHAZAD") || st.includes("NO CONFORME")) {
        return { bg: "red lighten-5", text: "red darken-3", icon: "mdi-close-circle" };
      }
      return { bg: "blue-grey lighten-5", text: "blue-grey darken-3", icon: "mdi-clock-outline" };
    },

    async exportToExcel() {
      if (this.filteredList.length === 0) {
        this.$fun.alert("No hay registros para exportar", "warning");
        return;
      }

      try {
        const workbook = new ExcelJS.Workbook();
        workbook.creator = "SunExpert";
        const worksheet = workbook.addWorksheet("Aprobación Materia Prima");

        // Title row
        worksheet.mergeCells(1, 1, 1, this.headers.length);
        const titleCell = worksheet.getCell(1, 1);
        titleCell.value = "REPORTE CONSOLIDADO DE APROBACIÓN DE MATERIA PRIMA POR LOTE";
        titleCell.font = { name: "Calibri", size: 12, bold: true, color: { argb: "FFFFFFFF" } };
        titleCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF1E88E5" } };
        titleCell.alignment = { vertical: "middle", horizontal: "center" };
        worksheet.getRow(1).height = 28;

        // Headers row
        const headersRowValues = this.headers.map((c) => c.text.toUpperCase());
        const headerRow = worksheet.addRow(headersRowValues);
        headerRow.height = 22;

        headerRow.eachCell((cell) => {
          cell.font = { name: "Calibri", size: 9, bold: true, color: { argb: "FFFFFFFF" } };
          cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF263238" } };
          cell.alignment = { vertical: "middle", horizontal: "center" };
          cell.border = {
            top: { style: "thin", color: { argb: "FFB0BEC5" } },
            left: { style: "thin", color: { argb: "FFB0BEC5" } },
            bottom: { style: "thin", color: { argb: "FFB0BEC5" } },
            right: { style: "thin", color: { argb: "FFB0BEC5" } },
          };
        });

        // Rows
        this.filteredList.forEach((item) => {
          const rowValues = this.headers.map((col) => {
            if (col.value === "RequiresAnalysis") {
              const req = item.RequiresAnalysis === 1 || item.RequiresAnalysis === "1" || item.RequiresAnalysis === true;
              return req ? "SÍ" : "NO";
            }
            const val = item[col.value];
            if (col.value.includes("Date")) {
              return val ? moment(val).format("DD/MM/YYYY") : "";
            }
            if (["PLOMO", "CADMIO", "NIQUEL"].includes(col.value)) {
              return val !== null && val !== undefined && val !== "" ? Number(val) : "";
            }
            return val !== null && val !== undefined ? val : "";
          });
          const row = worksheet.addRow(rowValues);
          row.eachCell((cell) => {
            cell.font = { name: "Calibri", size: 9 };
            cell.alignment = { vertical: "middle", wrapText: true };
            cell.border = {
              top: { style: "thin", color: { argb: "FFE0E0E0" } },
              left: { style: "thin", color: { argb: "FFE0E0E0" } },
              bottom: { style: "thin", color: { argb: "FFE0E0E0" } },
              right: { style: "thin", color: { argb: "FFE0E0E0" } },
            };
          });
        });

        // Auto width
        worksheet.columns.forEach((column) => {
          let maxLength = 12;
          column.eachCell({ includeEmpty: true }, (cell) => {
            const cellLength = cell.value ? String(cell.value).length : 0;
            if (cellLength > maxLength) {
              maxLength = Math.min(cellLength, 45);
            }
          });
          column.width = maxLength + 3;
        });

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, `Reporte_Aprobacion_Materia_Prima_${moment().format("YYYYMMDD_HHmm")}.xlsx`);
        this.$fun.alert("Archivo Excel generado con éxito", "success");
      } catch (err) {
        console.error("Error al exportar Excel:", err);
        this.$fun.alert("Error al generar el archivo Excel", "error");
      }
    },
  },
};
</script>

<style scoped>
.border-light {
  border: 1px solid #e2e8f0 !important;
}

.approval-table >>> .v-data-table__wrapper {
  max-height: calc(100vh - 340px) !important;
  overflow-y: auto !important;
}

.approval-table >>> th {
  position: sticky !important;
  top: 0 !important;
  z-index: 3 !important;
  font-weight: 700 !important;
  color: #1e293b !important;
  background-color: #f8fafc !important;
  font-size: 0.78rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid #e2e8f0 !important;
}

.approval-table >>> td {
  font-size: 0.82rem !important;
  border-bottom: 1px solid #f1f5f9 !important;
  white-space: normal !important;
  height: auto !important;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
  vertical-align: middle !important;
}

.approval-table >>> tr {
  height: auto !important;
}

.font-mono {
  font-family: Consolas, "Courier New", monospace !important;
}

.text-wrap {
  white-space: normal !important;
  word-break: break-word !important;
}

.cursor-pointer {
  cursor: pointer;
}

/* =========================================================================
   ESTILOS EJECUTIVOS PARA EL MODAL DE MERCADOS NO APTOS (SUNEXPERT FLAT UI)
   ========================================================================= */

.modal-header-dark {
  background-color: #0f172a !important;
  border-bottom: 1px solid #1e293b;
}

.line-height-tight {
  line-height: 1.25;
}

.modal-info-panel {
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
}

.info-label {
  font-size: 0.72rem;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  margin-right: 4px;
}

.info-value {
  font-size: 0.8rem;
  font-weight: 800;
  color: #0f172a;
}

.modal-instruction-box {
  background-color: #f0f9ff;
  border: 1px solid #bae6fd;
  border-left: 4px solid #0284c7;
}

.text-sky-dark {
  color: #0369a1;
  line-height: 1.4;
}

.modal-table-container {
  max-height: 340px;
  overflow-y: auto;
  border: 1px solid #e2e8f0;
}

.modal-table-header th {
  background-color: #f1f5f9 !important;
  color: #334155 !important;
  font-size: 0.75rem !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  border-bottom: 1px solid #cbd5e1 !important;
  padding: 8px 12px !important;
}

.row-prohibited-selected {
  background-color: #fff1f2 !important;
  border-left: 3.5px solid #e11d48 !important;
  transition: background-color 0.15s ease-in-out;
}

.row-prohibited-compliant {
  background-color: #ffffff !important;
  border-left: 3.5px solid transparent !important;
  transition: background-color 0.15s ease-in-out;
}

.row-prohibited-compliant:hover {
  background-color: #f8fafc !important;
}

.text-slate-800 {
  color: #1e293b !important;
}

.gap-1 {
  gap: 4px;
}

.substance-chip-restricted {
  display: inline-block;
  background-color: #fee2e2;
  color: #991b1b;
  border: 1px solid #fca5a5;
  font-size: 0.74rem;
  font-weight: 700;
  padding: 2px 7px;
  border-radius: 5px;
  line-height: 1.35;
  box-shadow: 0 1px 2px rgba(185, 28, 28, 0.06);
}

.substance-chip-ok {
  display: inline-flex;
  align-items: center;
  background-color: #f0fdf4;
  color: #166534;
  border: 1px solid #bbf7d0;
  font-size: 0.74rem;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 5px;
}

.status-chip-blocked {
  display: inline-flex;
  align-items: center;
  background-color: #fee2e2;
  color: #991b1b;
  border: 1px solid #fca5a5;
  font-size: 0.72rem;
  font-weight: 800;
  padding: 2px 8px;
  border-radius: 9999px;
}

.status-chip-allowed {
  display: inline-flex;
  align-items: center;
  background-color: #f0fdf4;
  color: #166534;
  border: 1px solid #86efac;
  font-size: 0.72rem;
  font-weight: 800;
  padding: 2px 8px;
  border-radius: 9999px;
}

.modal-actions-footer {
  background-color: #f8fafc;
  border-top: 1px solid #e2e8f0;
}

.btn-save-prohibited {
  background-color: #dc2626 !important;
  transition: all 0.15s ease-in-out;
}

.btn-save-prohibited:hover {
  background-color: #b91c1c !important;
  box-shadow: 0 2px 6px rgba(220, 38, 38, 0.3) !important;
}
</style>
